import styled from 'styled-components';
import {alignCenter, dFlex, flexColumn, justifyBetween} from '../../../globalVariables/GlobalFlex';
import {LIGHT_BLUE, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {popUpTop} from '../../newPopup/topPopup/TopPopup.css';
import {popUpBody} from '../../newPopup/mobilePopup/MobilePopup.css';
import {image} from '../../imagePopup/ImagePopup.css';
import {wrapCheckbox} from '../../checkboxFormik/CheckboxFormik.css';

export const promotionSection = styled.div`
    ${dFlex};
    padding-top: 80px;
    ${justifyBetween};
    ${mobileMedia}{
        ${flexColumn};
        gap: 20px;
    }
`;
export const promotionRight = styled.div`
    ${dFlex};
    ${justifyBetween};
    ${flexColumn};
`;

export const sectionTitle = styled.div`
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 8px;
    letter-spacing: 1.8px;
`;

export const sectionSubtitle = styled.div`
    font-size: 12px;
    letter-spacing: 0.6px;
    margin-bottom: 20px;
    max-width: 240px;
`;
export const checklistItem = styled.div`
    ${dFlex};
    ${alignCenter}
    ${wrapCheckbox}{
        width: max-content; 
        gap: 10px;
    }
    margin-bottom: 10px;
`;
export const promotionLeft = styled.div`
    ${dFlex};
    ${flexColumn};
    ${justifyBetween};
    gap: 10px;
    ${mobileMedia}{
        ${flexColumn};
        gap: 10px;
    }
    white-space: pre-line;
`;

export const wrap = styled.div``;

export const imagePopupWrapper = styled.div`
    ${popUpTop}{
        background-color: ${LIGHT_BLUE};
        width: auto !important;
        height: auto !important;
    }
    ${popUpBody} {
        width: auto !important;
        height: auto !important;
    }
`;
